<template>
  <div class="info">
    <icon-question ref="icon"
                   class="icon" />
    <div ref="dropdown"
         class="dropdown">
      <p>
        {{ $t("feed.blockWarnInfo.eventDescription") }}

        <router-link :to="{ name: 'faq', hash: '#first' }">
          {{ $t("learnWhy") }}
        </router-link>
      </p>
      <p>
        {{ $t("feed.blockWarnInfo.linkDescription") }}

        <router-link :to="{ name: 'faq', hash: '#second' }">
          {{ $t("moreInfo") }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import tippy from 'tippy.js'

  export default {
    mounted() {
      tippy(this.$refs.icon.$el,  {
        sticky: true,
        allowHTML: true,
        content: this.$refs.dropdown,
        trigger: 'click',
        hideOnClick: true,
        interactive: true,
        theme: 'custom-light',
        placement: 'right',
        animation: 'shift-away',
        arrow: true,
        inertia: true,
        duration: [400, 300]
      })
    }
  }
</script>

<style lang="scss" scoped>
  .info {
    position: absolute;
    right: 10px;
    top: 0;
  }

  .icon {
    cursor: pointer;
  }

  .dropdown {
    p {
      margin: 0 0 20px 0;
    }

    p:last-child {
      margin: 0;
    }

    padding: 16px;
    text-align: left;
  }
</style>
